var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0" },
    [
      _c(
        "v-layout",
        { attrs: { column: "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                {
                  attrs: {
                    extended: _vm.isMobile,
                    dense: !_vm.isMobile,
                    flat: ""
                  }
                },
                [
                  _c(
                    "template",
                    { slot: _vm.isMobile ? "extension" : "default" },
                    [
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-tabs",
                            {
                              attrs: {
                                left: !_vm.isMobile,
                                centered: _vm.isMobile,
                                grow: "",
                                "show-arrows": "",
                                color: "#f5f5f5",
                                "slider-color": "primary"
                              },
                              model: {
                                value: _vm.tab,
                                callback: function($$v) {
                                  _vm.tab = $$v
                                },
                                expression: "tab"
                              }
                            },
                            [
                              _c(
                                "v-tab",
                                { key: "TxnHistory" },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      staticClass: "align-center",
                                      attrs: { column: "" }
                                    },
                                    [
                                      _c("v-icon", [_vm._v("receipt")]),
                                      _vm._v(
                                        "\n                    Transaction History\n                  "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-tab",
                                { key: "LoadHistory" },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      staticClass: "align-center",
                                      attrs: { column: "" }
                                    },
                                    [
                                      _c("v-icon", [_vm._v("local_shipping")]),
                                      _vm._v(
                                        "\n                    Load History\n                  "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "v-tabs-items",
                {
                  model: {
                    value: _vm.tab,
                    callback: function($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab"
                  }
                },
                [
                  _c(
                    "v-tab-item",
                    {
                      key: "TxnHistory",
                      attrs: { transition: false, "reverse-transition": false }
                    },
                    [
                      _c(
                        "v-load-conversation",
                        {
                          staticClass: "mt-1",
                          attrs: {
                            "txn-id": _vm.transaction.id,
                            "max-height": "300"
                          }
                        },
                        [
                          _c(
                            "template",
                            { slot: "conversationBanner" },
                            [
                              _vm.transaction.customer.companyId
                                ? _c(
                                    "v-alert",
                                    {
                                      attrs: {
                                        value: true,
                                        color: "primary",
                                        icon: "info",
                                        outline: ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  A private conversation between the offices of " +
                                          _vm._s(
                                            _vm.transaction.customer.companyName
                                          ) +
                                          "\n                  and " +
                                          _vm._s(
                                            _vm.transaction.vendor.companyName
                                          ) +
                                          ".\n                "
                                      )
                                    ]
                                  )
                                : _c(
                                    "v-alert",
                                    {
                                      attrs: {
                                        value: true,
                                        color: "primary",
                                        icon: "info",
                                        outline: ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.transaction.customer.companyName
                                          ) +
                                          " does not have an " +
                                          _vm._s(_vm.$t("site-title.brief")) +
                                          " account. This is\n                  effectively a place for you to keep notes about this transaction.\n                "
                                      )
                                    ]
                                  )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tab-item",
                    {
                      key: "LoadHistory",
                      attrs: { transition: false, "reverse-transition": false }
                    },
                    [
                      _c(
                        "v-load-conversation",
                        {
                          staticClass: "mt-1",
                          attrs: {
                            "load-id": _vm.transaction.loadId,
                            "max-height": "300"
                          }
                        },
                        [
                          _c("template", { slot: "conversationBanner" }, [
                            _c("div", { staticClass: "pa-4" }, [
                              _vm._v(
                                "\n                  A fairly broad conversation between all the shipper employees, receiver\n                  employees, the driver, and the offices of " +
                                  _vm._s(_vm.transaction.customer.companyName) +
                                  "\n                  and " +
                                  _vm._s(_vm.transaction.vendor.companyName) +
                                  ".\n                "
                              )
                            ])
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b069578", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b069578","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoWidgets/LoadTransactionHistories.vue
// module id = null
// module chunks = 